/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'trash': {
    width: 16,
    height: 16,
    viewBox: '0 0 20.12 21.32',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M0 4.41h20.12M4.72 4.41V2.07A1.29 1.29 0 0 1 6 .75h8.16a1.29 1.29 0 0 1 1.24 1.32v2.34M8.01 6.35v9.91M12.11 6.35v9.91M16.63 18.41a2.12 2.12 0 0 1-2.07 2.17h-9a2.12 2.12 0 0 1-2.07-2.17V6.14M16.63 6.14V15"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/trash.js